import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
//import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  Container,
  FormWrapper
} from "../Advertisers/CreateAdvertisers/CreateAdvertisersStyles"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getPublisherById,
  updatePublisher,
} from "../../redux/slices/publisherSlice";

import BackButton from "../../components/common/BackButton";
import PostbackFields, { buildPostbackPayload, bodyToString } from "./PostbackFields";

const EditPublishers = () => {
  const dispatch = useDispatch();
  const { publisherId } = useParams();
  //console.log(publisherId);
  const { loading } = useSelector((state) => state.advertiser);
  const [initialFormData, setInitialFormData] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    publisherUrl: "",
    identifier: "",
    clickIdParameter: "",
    sourceIdParameter: "",
    postbackMethod: "GET",
    postbackBody: "",
    isActive: null,
  });
  // const [showPassword, setShowPassword] = useState(false);
  // const toggleType = () => {
  //   setShowPassword(!showPassword);
  // };

  useEffect(() => {
    dispatch(getPublisherById(publisherId)).then((response) => {
      if (response.payload) {
        const fetchedData = response.payload.data;
        //console.log(fetchedData)

        //formData.userId = fetchedData.userId;
        const existingFormData = {
          name: fetchedData.publisher.name || "",
          publisherUrl: fetchedData.publisher.publisherUrl || "",
          identifier: fetchedData.publisher.identifier || "",
          clickIdParameter: fetchedData.publisher.clickIdParameter || "",
          sourceIdParameter: fetchedData.publisher.sourceIdParameter || "",
          postbackMethod: fetchedData.publisher.postbackMethod || "GET",
          postbackBody: bodyToString(fetchedData.publisher.postbackBody),
          isActive: fetchedData.publisher.isActive || false,
        };
        //console.log(existingFormData);

        setFormData(existingFormData);
        setInitialFormData(existingFormData); // Save initial data for comparison
      }
    });
  }, [dispatch, publisherId]);


  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "isActive" ? (value === "true" ? true : value === "false" ? false : null) : value,
    }));
  };
  
  
  const trimFormValues = (values) => {
    const trimmedValues = {};
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        trimmedValues[key] = values[key].trim(); // Trim strings
      } else if (typeof values[key] === "object" && values[key] !== null) {
        // Recursively trim nested objects if any
        trimmedValues[key] = trimFormValues(values[key]);
      } else {
        trimmedValues[key] = values[key]; // Keep other types as they are
      }
    });
    return trimmedValues;
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const trimmedFormData = trimFormValues(formData);
    const trimmedInitialData = trimFormValues(initialFormData);

    const parsedFormData = {
      ...trimmedFormData,
      //isActive: trimmedFormData.isActive === "true" ? true : false,
    };

    // Compare the trimmed form data
    if (
      JSON.stringify(parsedFormData) === JSON.stringify(trimmedInitialData)
    ) {
      Swal.fire({
        title: "No Changes Made",
        text: "You have not made any changes to the campaign.",
        icon: "info",
      });
      return;
    }
    const payload = buildPostbackPayload(formData);
    if (!payload) return;
    dispatch(updatePublisher({ id: publisherId, formData: payload }));
  };

  return (
    <>
    <BackButton></BackButton>
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Update Publisher</h3>
          <p>
            Set up a publisher profile to get them started with campaigns and
            tracking.
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <FormWrapper className="full-width">
          <label htmlFor="name">Publisher name</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Publisher name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper className="full-width">
          <label htmlFor="publisherUrl">Url</label>
          <input
            type="text"
            id="publisherUrl"
            name="publisherUrl"
            placeholder="Url"
            value={formData.publisherUrl}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <PostbackFields formData={formData} onChange={handleChange} Wrapper={FormWrapper} />

        <FormWrapper className="grid-row-3">
          <div className="field-group">
            <label htmlFor="identifier">Identifier</label>
            <input
              type="text"
              id="identifier"
              name="identifier"
              placeholder="Identifier"
              value={formData.identifier}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label htmlFor="clickIdParameter">click Id</label>
            <input
              type="text"
              id="clickIdParameter"
              name="clickIdParameter"
              placeholder="click Id"
              value={formData.clickIdParameter}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-group">
            <label htmlFor="sourceIdParameter">Source Id</label>
            <input
              type="text"
              id="sourceIdParameter"
              name="sourceIdParameter"
              placeholder="Source Id"
              value={formData.sourceIdParameter}
              onChange={handleChange}
              required
            />
          </div>
        </FormWrapper>

        <FormWrapper className="full-width">
          <label htmlFor="isActive">Status</label>
          <select
            type="text"
            id="isActive"
            name="isActive"
            value={formData.isActive}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              marginTop: "10px",
              border: "2px solid #e3f2fd",
              borderRadius: "10px",
              padding: "12px 16px",
              fontSize: "14px",
              color: "#1a237e",
              background: "#ffffff",
              transition: "all 0.3s ease",
            }}
            onFocus={(e) => {
              e.target.style.outline = "none";
              e.target.style.borderColor = "#03a9f4";
              e.target.style.boxShadow = "0 0 0 3px rgba(3, 169, 244, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#e3f2fd";
              e.target.style.boxShadow = "none";
            }}
          >
            <option value={null}>Select status</option>
            <option value={true}>Active</option>
            <option value={false}>Inactive</option>
          </select>
        </FormWrapper>

        <div className="submit">
          <div></div>
          <div className="submit-buttons">
            <button className="add-campaign" type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </div>
      </form>
    </Container>
    </>
  );
};

export default EditPublishers;
